import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import NOIBox from "./NOIBox";

import { buildIncreaseData } from "../../sample";
import { noiEndPoints } from "../../../../services/apiEndPoints";
import { currencyFormatter } from "../../../../services/utils";
import { getData } from "../../../../services/api";

const BuildIncrease = ({ filtervalue, handleChange, existingNoi, value }) => {
  const [buildIncrease, setBuildIncrease] = useState(buildIncreaseData);
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);
  const { period, startDate, endDate } = useSelector((state) => state.selectedPeriods);

  useEffect(() => {
    const dateQueryParams = {
      period,
      startDate,
      endDate,
    };
    if (filtervalue) {
      getData(
        noiEndPoints.BUILD_INCREASE,
        (data) => {
          setBuildINcreasePowerRevenue(data, filtervalue);
        },
        {
          target_cap_rate: filtervalue,
          existing_noi: existingNoi * 1000000,
          ...dateQueryParams,
        }
      );
    }
  }, [period, startDate, endDate, filtervalue]);

  const setBuildINcreasePowerRevenue = (buildIncreaseData, exitingParameter) => {
    setBuildIncrease((prevState) => {
      return {
        ...prevState,
        rows: prevState.rows.map((val) => {
          if (!buildIncreaseData[val.key] && buildIncreaseData[val.key] !== 0)
            return { ...val, value: exitingParameter };
          return {
            ...val,
            value:
              val.key !== "building_value_increase"
                ? currencyFormatter(buildIncreaseData[val.key], currencySymbol)
                : `${buildIncreaseData[val.key].toFixed(1).toString().replace(/\.0$/, "")}%`,
          };
        }),
        chartData: {
          ...prevState.chartData,
          data: prevState.chartData.data.map(() => {
            return {
              power_revenue_value: buildIncreaseData.power_revenue_noi,
              existing_building_value: buildIncreaseData.existing_building_value,
            };
          }),
        },
      };
    });
  };

  return <NOIBox item={buildIncrease} filtervalue={value} handleChange={handleChange} />;
};

export default BuildIncrease;
